<template>
  <div class="w-100">
    <terms-and-privacy-c :siteData="siteData" v-if="!privacyAndTermsToSignUpFields"></terms-and-privacy-c>
    <sign-up-fields-c v-if="privacyAndTermsToSignUpFields"></sign-up-fields-c>
  </div>
</template>

<script>
import termsAndPrivacyC from './signUpC/termsAndPrivacyC.vue'
import signUpFieldsC from './signUpC/signUpFieldsC.vue'

export default {
  name: 'signUpC',
  extends: {},
  props: {
    siteData: {
      type: String,
      required: false
    }
  },
  data(){
    return {
      privacyAndTermsRadio: false,
      privacyAndTermsToSignUpFields: false
    }
  },
  components: {
    'terms-and-privacy-c': termsAndPrivacyC,
    'sign-up-fields-c': signUpFieldsC
  },
  computed: {},
  watch: {},
  methods: {},
  beforeCreate(){},
  mounted(){}
}
</script>
